export default __webpack_public_path__ + "static/media/mid.d6410edd.png";